module.exports = __webpack_public_path__ + "img/category-How-to.fe8b2dba.svg";